import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PageAdvertisement } from '../../../../models/entities/page-advertisement';
import { Router } from '@angular/router';

@Component({
    selector: 'app-feature-dialog',
    templateUrl: './feature-dialog.component.html',
    styleUrls: ['feature-dialog.component.scss'],
})
export class FeatureDialogComponent
{
    constructor(
            private _router: Router,
            private _dialogRef: MatDialogRef<FeatureDialogComponent>,
            @Inject(MAT_DIALOG_DATA) public data: PageAdvertisement,
    ) {
    }

    openTab() {
        this._dialogRef.close();

        // open call-to-action link in new tab for now
        window.open(this.data.cta.url, '_blank');
    }

    redirect() {
        this._dialogRef.close();

        // navigate to call-to-action path
        return this._router.navigate([this.data.cta.url]);
    }
}
